var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisconnectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.85253 0V9.25293H9.14747V0H6.85253ZM2.34277 2.34277C0.895053 3.79049 0 5.79085 0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 5.79085 15.1049 3.79049 13.6572 2.34277L12.0459 3.95411C13.0814 4.98955 13.7217 6.42013 13.7217 8C13.7217 11.1597 11.1597 13.7217 8 13.7217C4.84025 13.7217 2.27832 11.1597 2.27832 8C2.27832 6.42013 2.91865 4.98955 3.95411 3.95411L2.34277 2.34277Z",
    fill: "#E4151B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisconnectIcon);
export default __webpack_public_path__ + "static/media/disconnect-icon.90ef1e478b3f13078d1035f3bb8f5fc0.svg";
export { ForwardRef as ReactComponent };